import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AboutUs from "./Aboutus";
import ContactUs from "./ContactUs";
import OurServices from "./Services";
import HeroBanner from "./HeroBanner";
import Specialties from "./Specialties";
import Testimonials from "./Testimonials";
import Faq from "./Faq";
import Placement from "./Placement";
import Gallery from "./Gallery";
import Certifications from "./Certifications";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        setTimeout(() => {
          sectionElement.scrollIntoView({ behavior: "smooth" });
        }, 200); // small delay so DOM is ready
      }
    }
  }, [location]);

  return (
    <div>
      {/* ✅ Add Helmet here */}
      <Helmet>
        <title>Circutech | Innovative Tech & IT Solutions</title>
        <meta
          name="description"
          content="Circutech delivers smart technology solutions including web development, IT consulting, and automation services. Partner with us for your digital transformation."
        />
        <meta
          name="keywords"
          content="Circutech, IT solutions, web development, technology consulting, software services, automation"
        />
      </Helmet>
      <section id="home">
        <HeroBanner />
      </section>

      <section id="services">
        <OurServices />
      </section>

      {/* <section id="certifications">
        <Certifications />
      </section> */}


      <section id="about">
        <AboutUs />
      </section>

      <section id="contact">
        <ContactUs />
      </section>

        <section id="gallery">
        <Gallery />
      </section>

      <Specialties />
      <section id="faq">
        <Faq />
      </section>
      {/* <Testimonials /> */}
      <section id="placement">
        <Placement />
      </section>
    </div>
  );
};

export default Home;
